module.exports = __webpack_public_path__ + "assets/logo-default-stand.41c48676c0ef48489a56128baa31f3db.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/logo-default-stand.png
 ** module id = 198
 ** module chunks = 0
 **/